module.exports = __webpack_public_path__ + "src/images/lady-with-remote.png";